import { faArrowRight, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { getShoppingBasketListApi, PaymentPageApi, UpdateCartApi } from '../../Api/ClientServices'
import Button from '../../Components/Button/Button'
import Style from './ShoppingBasket.module.css'
import ReactLoading from 'react-loading';
import { separate } from '../../Utils/Seprate/Seprate'
import { errorToast, succToast } from '../../Utils/Toast/Toast'

const ShoppingBasket = () => {
    const history=useHistory()
    const[list,setList]=useState([])
    const[loading,setLoading]=useState(false)
    const[loadingAll,setLoadingAll]=useState(false)
    useEffect(()=>{
        getShoppingBasketList()
    },[])
    const getShoppingBasketList=async()=>{
        const data= await getShoppingBasketListApi()
        setList(data.cart)
    }
    const RemoveHandler=(id)=>{
        setLoading(true)
        let info={
            course_id:id,
            count:0
        }
        UpdateCartApi(info,(succ)=>{
            if(succ.status){
                succToast('با موفقیت از سبد خرید شما حذف شد')
                setLoading(false)
                getShoppingBasketList()
            }
            else{
                errorToast(succ.message)
                setLoading(false)
            }
        })
    }
    const PaymentHandler=()=>{
        setLoadingAll(true)
        PaymentPageApi((succ)=>{
            if(succ.status===1){
                succToast('شما تا چند لحظه دیگر وارد صفحه پرداخت میشوید')
                setTimeout(() => {
                    window.location.href = succ.link
                }, 3000);
                setLoadingAll(false)
            }
            else{
                errorToast(succ.message)
                setLoadingAll(false)
            }
        })
    }
    let loadingHandler=null
    if(list===undefined){
        loadingHandler=<div className='w-100 d-flex align-items-center justify-content-center'>
        <ReactLoading type={'cylon'} color={'#096CCC'} />
        <p style={{marginTop:'3rem',color:"#fff"}}>لطفا منتظر باشید</p>
      </div>
    }
    else if(list.length===0){
        loadingHandler=<p style={{color:'#096CCC'}}>سبد خرید شما خالی است</p>
    }
    else{
        loadingHandler=list.map(item=>{
            return(
                <li key={item.id} className={Style.CourseInList}>
                <h3><span>{item.id}_</span>{item.name}</h3>
                    <p>{separate(item.price)} تومان </p>
                    <FontAwesomeIcon icon={faTrash} onClick={()=>RemoveHandler(item.id)}/>
                </li>
            )
        })
    }
    let Totalprice=0
    list.forEach(element => {
        Totalprice=Totalprice+parseInt(element.price)
    });
    return (
        <div className='pageHolder'>
            {
                loadingAll?
                <div className={Style.LoadingAllpage}>
                    <ReactLoading type={'cylon'} color={'#096CCC'} />
                    <p style={{marginTop:'3rem',color:"#fff"}}>لطفا منتظر باشید</p>
                </div>:null
            }
            <div   className={loading?Style.LoadingHolder:'d-none'}>
                <ReactLoading type={'cylon'} color={'#096CCC'} />
            </div>
            <p className={Style.Shoppingheader}>سبد خرید شما <FontAwesomeIcon onClick={() => history.goBack()} icon={faArrowRight}/></p>
            <img src="/Assets/Images/Regular/basket.svg" alt="basket"  className={Style.ImageHolder}/>
            <section className={Style.BasketHolder}>
                <p>دوره های انتخاب شده</p>
                <ul className='pageHolder' style={{padding:0}}>
                   {
                       loadingHandler
                   }
                    
                </ul>
            </section>
            <div className={Style.TotalPrice}><h3>مجموع</h3><p>{separate(Totalprice)} تومان </p></div>
            <Button Value={'پرداخت'} ClassBtn={'buyBtn'} clickhandler={PaymentHandler}/>
        </div>
    )
}

export default ShoppingBasket
